// extracted by mini-css-extract-plugin
export default {"row":"y54Y47mT","ad-site-wrapper-small":"ad-site-wrapper-small","type1":"U4VZu1oo","content":"QIb7oXI0","image":"k4X4XcFp","beautyTime":"VeNO87nW","time":"UThOHdKk"};